import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { LifestyleService } from 'src/app/services/ha-new/lifestyle.service';
import { SpinnerComponent } from 'src/app/modules/shared/spinner/spinner.component';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from 'src/app/services/ha-new/lookup.service';
import { NewHAService } from 'src/app/services/ha-new/new-ha.service';

@Component({
	selector: 'app-how-you-think',
	templateUrl: './how-you-think.component.html',
	styleUrls: ['./how-you-think.component.scss'],
})
export class HowYouThinkComponent implements OnInit {
	subscriptions: Subscription[] = [];
	/** holds ha id */
	healthAssessmentID: number = 0;
	/** holds appointment id */
	apptID: any;
	/** holds readOnly flag */
	readOnly: boolean = false;
	howYouThinkData: any = {};
	scrollTo = '';
	botheredByProblemsLookup: any = [];
	considerMyselfRatingLookup: any = [];
	characterizationLookup: any = [];
	thinkReactionOptions: any = [];
	howYouThinkForm: FormGroup;
	considerMyselfSlider: any = {};
	characterizationSlider: any = {};
	returningUser: boolean = false;

	constructor(
		private lifestyleService: LifestyleService,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private haService: NewHAService
	) {
		this.activatedRoute.queryParams.subscribe(params => {
			//console.log('params:', params);
			this.apptID = params.apptID;
			this.readOnly = params.readOnly === 'true';
			this.healthAssessmentID = params.healthAssessmentID;
			this.returningUser = params.returningUser === 'true';
			if (this.scrollTo != 'false') this.scrollTo = params.section;
		});
	}

	ngOnInit() {
		this.initializeHowYouThinkForm();
		this.getLookupOptions();
	}

	considerMyselfSliderTickInterval(): number | 'auto' {
		return this.considerMyselfSlider.tickInterval;
	}

	characterizationSliderTickInterval(): number | 'auto' {
		return this.characterizationSlider.tickInterval;
	}

	initializeHowYouThinkForm() {
		this.howYouThinkForm = new FormGroup({
			lastTwoWeeksFeelingNervous: new FormControl(''),
			lastTwoWeeksUnableStopWorrying: new FormControl(''),
			lastTwoWeeksLittleInterest: new FormControl(''),
			lastTwoWeeksFeelingDepressed: new FormControl(''),
			inGeneralConsiderMyself: new FormControl(''),
			comparedToMostConsiderMyself: new FormControl(''),
			characterizationDescribeGenerallyVeryHappy: new FormControl(''),
			characterizationDescribeGenerallyNotVeryHappy: new FormControl(''),
			tendToBounceBackAfterHardTimes: new FormControl(''),
			hardTimeMakingThroughStress: new FormControl(''),
			doesNotTakeLongToRecover: new FormControl(''),
			hardToSnapBackWhenBadHappens: new FormControl(''),
			comeThroughDifficultTimesEasily: new FormControl(''),
			takeLongTimeToGetOverSetbacks: new FormControl(''),
			victimDomesticViolencePast: new FormControl(''),
			committedDomesticViolencePast: new FormControl(''),
		});
	}

	getHowYouThink(data) {
		this.howYouThinkData = data;

		//console.log(this.howYouThinkData)

		this.howYouThinkForm.controls.victimDomesticViolencePast.setValue(this.howYouThinkData.victimDomesticViolencePast);
		this.howYouThinkForm.controls.committedDomesticViolencePast.setValue(
			this.howYouThinkData.committedDomesticViolencePast
		);
		this.howYouThinkForm.controls.lastTwoWeeksUnableStopWorrying.setValue(
			this.howYouThinkData.lastTwoWeeksUnableStopWorrying
		);
		this.howYouThinkForm.controls.lastTwoWeeksFeelingNervous.setValue(this.howYouThinkData.lastTwoWeeksFeelingNervous);
		this.howYouThinkForm.controls.lastTwoWeeksLittleInterest.setValue(this.howYouThinkData.lastTwoWeeksLittleInterest);
		this.howYouThinkForm.controls.lastTwoWeeksFeelingDepressed.setValue(
			this.howYouThinkData.lastTwoWeeksFeelingDepressed
		);

		if (this.howYouThinkData.inGeneralConsiderMyself) {
			this.howYouThinkForm.controls.inGeneralConsiderMyself.setValue(this.howYouThinkData.inGeneralConsiderMyself);
		}
		if (this.howYouThinkData.comparedToMostConsiderMyself) {
			this.howYouThinkForm.controls.comparedToMostConsiderMyself.setValue(
				this.howYouThinkData.comparedToMostConsiderMyself
			);
		}

		if (this.howYouThinkData.characterizationDescribeGenerallyVeryHappy) {
			this.howYouThinkForm.controls.characterizationDescribeGenerallyVeryHappy.setValue(
				this.howYouThinkData.characterizationDescribeGenerallyVeryHappy
			);
		}

		if (this.howYouThinkData.characterizationDescribeGenerallyNotVeryHappy) {
			this.howYouThinkForm.controls.characterizationDescribeGenerallyNotVeryHappy.setValue(
				this.howYouThinkData.characterizationDescribeGenerallyNotVeryHappy
			);
		}

		this.howYouThinkForm.controls.tendToBounceBackAfterHardTimes.setValue(
			this.howYouThinkData.tendToBounceBackAfterHardTimes
		);
		this.howYouThinkForm.controls.hardTimeMakingThroughStress.setValue(
			this.howYouThinkData.hardTimeMakingThroughStress
		);
		this.howYouThinkForm.controls.doesNotTakeLongToRecover.setValue(this.howYouThinkData.doesNotTakeLongToRecover);
		this.howYouThinkForm.controls.hardToSnapBackWhenBadHappens.setValue(
			this.howYouThinkData.hardToSnapBackWhenBadHappens
		);
		this.howYouThinkForm.controls.comeThroughDifficultTimesEasily.setValue(
			this.howYouThinkData.comeThroughDifficultTimesEasily
		);
		this.howYouThinkForm.controls.takeLongTimeToGetOverSetbacks.setValue(
			this.howYouThinkData.takeLongTimeToGetOverSetbacks
		);
		//console.log(this.howYouThinkForm.getRawValue())
	}

	getLookupOptions() {
		this.spinner.startLoader();
		forkJoin({
			getHowYouThinkProblemOptionsLookup: this.lookupService.getHowYouThinkProblemOptionsLookup(),
			getConsiderMyselfRatingLookup: this.lookupService.getConsiderMyselfRatingLookup(),
			getCharacterizationDescribeRatingOptionsLookup:
				this.lookupService.getCharacterizationDescribeRatingOptionsLookup(),
			getThinkReactionOptionsLookup: this.lookupService.getThinkReactionOptionsLookup(),
			howYouThink: this.lifestyleService.getHowYouThink(this.apptID, this.healthAssessmentID),
		}).subscribe(
			res => {
				this.botheredByProblemsLookup = res.getHowYouThinkProblemOptionsLookup.data;

				this.considerMyselfRatingLookup = res.getConsiderMyselfRatingLookup.data;

				this.considerMyselfSlider['max'] = this.considerMyselfRatingLookup.length;
				this.considerMyselfSlider['min'] = 1;
				this.considerMyselfSlider['showTicks'] = true;
				this.considerMyselfSlider['step'] = '1';
				this.considerMyselfSlider['tickInterval'] = '1';

				this.characterizationLookup = res.getCharacterizationDescribeRatingOptionsLookup.data;
				this.characterizationSlider['max'] = this.characterizationLookup.length;
				this.characterizationSlider['min'] = 1;
				this.characterizationSlider['showTicks'] = true;
				this.characterizationSlider['step'] = '1';
				this.characterizationSlider['tickInterval'] = '1';

				this.thinkReactionOptions = res.getThinkReactionOptionsLookup.data;
				this.getHowYouThink(res.howYouThink.data);

				this.spinner.stopLoader();
				if (this.scrollTo != 'false') {
					if (this.haService.scrollView(this.scrollTo)) {
						this.scrollTo = 'false';
					}
				}
			},
			err => {
				console.error(`[${HowYouThinkComponent.name}][${this.getLookupOptions.name}]`, 'error getting how you think data', err);
				this.spinner.stopLoader();
			}
		);
	}
	next() {
		if (!this.readOnly) {
			if (this.howYouThinkForm.valid) {
				this.saveHowYouThink();
			}
		}
	}

	saveHowYouThink() {
		//console.log(this.howYouThinkForm.getRawValue())
		const data = this.howYouThinkForm.getRawValue();
		// Prepopulated value if available and the value has not been updated
		if (this.haService.isValidIndex(data.inGeneralConsiderMyself)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('inGeneralConsiderMyself'))) {
				// data.inGeneralConsiderMyself = data.inGeneralConsiderMyself;
			} else if (this.howYouThinkData.inGeneralConsiderMyself) {
				data.inGeneralConsiderMyself = this.howYouThinkData.inGeneralConsiderMyself;
			} else {
				data.inGeneralConsiderMyself = undefined;
			}
		} else {
			data.inGeneralConsiderMyself = undefined;
		}
		if (this.haService.isValidIndex(data.comparedToMostConsiderMyself)) {
			if (this.returningUser || (!this.returningUser && this.selectionMade('comparedToMostConsiderMyself'))) {
				//data.comparedToMostConsiderMyself = data.comparedToMostConsiderMyself;
			} else if (this.howYouThinkData.comparedToMostConsiderMyself) {
				data.comparedToMostConsiderMyself = this.howYouThinkData.comparedToMostConsiderMyself;
			} else {
				data.comparedToMostConsiderMyself = undefined;
			}
		} else {
			data.comparedToMostConsiderMyself = undefined;
		}
		if (this.haService.isValidIndex(data.characterizationDescribeGenerallyVeryHappy)) {
			if (
				this.returningUser ||
				(!this.returningUser && this.selectionMade('characterizationDescribeGenerallyVeryHappy'))
			) {
				//data.characterizationDescribeGenerallyVeryHappy = data.characterizationDescribeGenerallyVeryHappy;
			} else if (this.howYouThinkData.characterizationDescribeGenerallyVeryHappy) {
				data.characterizationDescribeGenerallyVeryHappy =
					this.howYouThinkData.characterizationDescribeGenerallyVeryHappy;
			} else {
				data.characterizationDescribeGenerallyVeryHappy = undefined;
			}
		} else {
			data.characterizationDescribeGenerallyVeryHappy = undefined;
		}
		if (this.haService.isValidIndex(data.characterizationDescribeGenerallyNotVeryHappy)) {
			if (
				this.returningUser ||
				(!this.returningUser && this.selectionMade('characterizationDescribeGenerallyNotVeryHappy'))
			) {
			} else if (this.howYouThinkData.characterizationDescribeGenerallyNotVeryHappy) {
				data.characterizationDescribeGenerallyNotVeryHappy =
					this.howYouThinkData.characterizationDescribeGenerallyNotVeryHappy;
			} else {
				data.characterizationDescribeGenerallyNotVeryHappy = undefined;
			}
		} else {
			data.characterizationDescribeGenerallyNotVeryHappy = undefined;
		}
		this.subscriptions.push(
			this.lifestyleService
				.saveHowYouThink(this.apptID, {
					...data,
					healthAssessmentID: this.howYouThinkData.healthAssessmentID,
				})
				.subscribe(
					res => {
						this.haService.redirect(
							[],
							[],
							['work-life-balance'],
							this.apptID,
							this.healthAssessmentID,
							this.readOnly,
							'lifestyle-work-life-balance',
							this.returningUser
						);
					},
					err => {
						console.log(err);
					}
				)
		);
	}

	selectionMade(slider) {
		return this.howYouThinkForm.get(slider).touched;
	}
}
